var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    rx: 34.5,
    fill: "#EDF3FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4897 31.4963H47.2932V31.4327H33.9245V37.566H42.3193C41.0946 41.1364 37.8036 43.6993 33.9245 43.6993C29.0026 43.6993 25.012 39.58 25.012 34.4993C25.012 29.4186 29.0026 25.2993 33.9245 25.2993C36.1964 25.2993 38.2634 26.1841 39.8372 27.6292L44.0387 23.2922C41.3857 20.74 37.8371 19.166 33.9245 19.166C25.7213 19.166 19.0703 26.0315 19.0703 34.4993C19.0703 42.9672 25.7213 49.8327 33.9245 49.8327C42.1277 49.8327 48.7786 42.9672 48.7786 34.4993C48.7786 33.4712 48.6762 32.4677 48.4897 31.4963Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7832 27.3624L25.6635 31.057C26.9841 27.6821 30.1822 25.2993 33.9247 25.2993C36.1966 25.2993 38.2636 26.1841 39.8374 27.6292L44.0389 23.2922C41.3859 20.74 37.8373 19.166 33.9247 19.166C28.2192 19.166 23.2713 22.491 20.7832 27.3624Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9251 49.8327C37.7619 49.8327 41.2482 48.317 43.8841 45.8522L39.2867 41.8364C37.7953 43.0025 35.9415 43.6994 33.9251 43.6994C30.0615 43.6994 26.781 41.1563 25.5451 37.6074L20.7012 41.4599C23.1595 46.4256 28.152 49.8327 33.9251 49.8327Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4901 31.4963H47.2936V31.4326H33.9248V37.5659H42.3196C41.7314 39.281 40.6627 40.7599 39.2842 41.837C39.2849 41.8363 39.2857 41.8363 39.2864 41.8355L43.8838 45.8513C43.5585 46.1564 48.779 42.1659 48.779 34.4993C48.779 33.4712 48.6765 32.4676 48.4901 31.4963Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleicon);
export default __webpack_public_path__ + "static/media/googleicon.542f398fea5ae6b2fe39cae9b7f322da.svg";
export { ForwardRef as ReactComponent };